"use strict";

const { list } = require("angular-perfect-scrollbar-2");

module.exports = [
  "$uibModalInstance",
  "clients",
  "clientsAll",
  "memberSelected",
  "members",
  "Member",
  "myTenant",
  "toast",
  "Company",
  "Authentication",
  "$translate",
  "dialog",
  "$timeout",
  function ($uibModalInstance, clients, clientsAll, memberSelected, members, Member, myTenant, toast, Company, Authentication, $translate, dialog, $timeout) {
    var _this = this;
    _this.clients = clients;
    _this.clientsAll = clientsAll;
    let tenant = myTenant.get();
    _this.member = JSON.parse(
      JSON.stringify(
        memberSelected || {
          addedDirectly: true,
          emailVerified: true,
          tenantId: tenant.id,
          clients:[]
        }
      )
    );
    _this.clientsSelected = (_this.member.clients || []).map(clt=>clt.id);
    _this.apiToken = null;
    _this.apiTokenBusy = false;
    _this.showApiToken = false;
    _this.apiTokenChecked = false;
    _this.canManageApiToken = !!(
      _this.member.id &&
      (
        Authentication.isAuthorized('admin') ||
        String(_this.member.id) === String(Authentication.currentUser())
      )
    );

    this.members = members;
    this.companyList = [];
    // this.companiesForDirective = []; // Companies for input-select directive

    this.clickClient = (clientId) => {
        let idx = _this.clientsSelected.indexOf(clientId)
        if (idx == -1) {
            _this.clientsSelected.push(clientId);
        }
        else {
            _this.clientsSelected.splice(idx, 1);
        }
    }

    this.addUser = function () {        
        delete _this.member.roles;
        delete _this.member.device;
        delete _this.member.$$hashKey;
        delete _this.member.company

        const isNewUser = !_this.member.id;
        if (isNewUser && !_this.member.password) {
            toast.error($translate.instant('DASHBOARD.DASH_USERS.PASSWORD_REQUIRED'));
            return;
        }
        if (!isNewUser && !_this.member.password) {
            delete _this.member.password;
        }

        const saveMember = isNewUser
            ? (onSaved, onError) => Member.upsert(_this.member, onSaved, onError)
            : (onSaved, onError) => Member.prototype$updateAttributes(
                { id: _this.member.id },
                _this.member,
                onSaved,
                onError
            );

        saveMember(
            function (member) {
                Member.addClients(
                    { memberId: member.id },
                    _this.clientsSelected
                ).$promise.then(function (data) {
                    let memberData = JSON.parse(JSON.stringify(data));
                    member.clients = _this.clientsAll.filter(clt =>
                        _this.clientsSelected.includes(clt.id)
                    );
                    member.roles = memberSelected
                        ? memberSelected.roles
                        : (member.roles || []);
                    member.device = memberSelected
                        ? memberSelected.device
                        : (member.device || []);
                    if (memberSelected) {
                        member.$$hashKey = memberSelected.$$hashKey;
                    }
                    if (memberData.response && memberData.response.companyId) {
                        member.company = _this.companyList.find(
                            (company) => company.id == memberData.response.companyId
                        );
                    }
                    $uibModalInstance.close(member);
                });
            },
            function (err) {
                toast.success(err.data.error.message);
            }
        );
    };

    // this.getCompanies = function() {
    //     let uniqueCompaniesSet = new Set();
    //     this.members.forEach(member => {
    //         if (member.company && member.company.trim() !== '') {
    //             uniqueCompaniesSet.add(member.company); // No converting to lowercase here.
    //         }
    //     });
    //     this.companies = Array.from(uniqueCompaniesSet);
        
    //     // Sort without case sensitivity.
    //     this.companies.sort((a, b) => {
    //         const companyA = a.toLowerCase();
    //         const companyB = b.toLowerCase();
    //         return companyA.localeCompare(companyB, 'es', { sensitivity: 'base' });
    //     });
        
    //     this.companiesForDirective = this.companies;
    // }

    this.getCompanies = () => {
        Company.find().$promise.then(function (data) {
            _this.companyList = JSON.parse(JSON.stringify(data));
            return;
        })
        .catch(function (error) { 
            console.error(error);
        });
    }

    const getApiTokenId = (payload) => {
        if (!payload) {
            return null;
        }
        if (typeof payload === 'string') {
            return payload;
        }
        const source = payload.result || payload;
        return source._id || source.id || null;
    };

    const getErrorMessage = (err, fallbackKey) => {
        return (err && err.data && err.data.error && err.data.error.message)
            || $translate.instant(fallbackKey);
    };

    this.loadApiToken = () => {
        if (!_this.canManageApiToken) {
            return;
        }
        _this.apiTokenChecked = false;
        Member.getApiToken({
            memberId: _this.member.id
        }).$promise.then((tokens) => {
            if (tokens && tokens.length) {
                _this.apiToken = getApiTokenId(tokens[0]);
            }
            _this.apiTokenChecked = true;
        }).catch(() => {
            _this.apiTokenChecked = false;
        });
    };

    this.generateApiToken = () => {
        if (!_this.canManageApiToken || !_this.apiTokenChecked || _this.apiToken || _this.apiTokenBusy) {
            return;
        }
        _this.apiTokenBusy = true;
        Member.generateApiToken(
            { memberId: _this.member.id },
            {}
        ).$promise.then((data) => {
            _this.apiToken = getApiTokenId(data);
            if (!_this.apiToken) {
                toast.error($translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.GENERATE_ERROR'));
            } else {
                _this.showApiToken = false;
            }
        }).catch((err) => {
            toast.error(getErrorMessage(err, 'DASHBOARD.DASH_USERS.API_TOKEN.GENERATE_ERROR'));
        }).finally(() => {
            _this.apiTokenBusy = false;
        });
    };

    this.copyApiToken = () => {
        if (!_this.apiToken) {
            return;
        }
        const showCopied = () => {
            toast.success($translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.COPIED'));
        };
        const showError = () => {
            toast.error($translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.COPY_ERROR'));
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(_this.apiToken).then(() => {
                $timeout(showCopied);
            }).catch(() => {
                $timeout(showError);
            });
            return;
        }
        try {
            const input = document.createElement('textarea');
            input.value = _this.apiToken;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(input);
            if (ok) {
                showCopied();
            } else {
                showError();
            }
        } catch (e) {
            showError();
        }
    };

    this.deleteApiToken = () => {
        if (!_this.canManageApiToken || !_this.apiToken || _this.apiTokenBusy) {
            return;
        }
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.DIAG_DEL.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.DIAG_DEL.BODY'),
            accept: $translate.instant('DASHBOARD.DASH_USERS.API_TOKEN.DIAG_DEL.ACCEPT'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(() => {
            _this.apiTokenBusy = true;
            return Member.deleteApiToken({
                memberId: _this.member.id
            }).$promise.then(() => {
                _this.apiToken = null;
                _this.showApiToken = false;
            }).catch((err) => {
                toast.error(getErrorMessage(err, 'DASHBOARD.DASH_USERS.API_TOKEN.DELETE_ERROR'));
            }).finally(() => {
                _this.apiTokenBusy = false;
            });
        }).catch(() => {});
    };

    this.toggleApiTokenVisibility = ($event) => {
        _this.showApiToken = !_this.showApiToken;
        if ($event && $event.currentTarget && $event.currentTarget.blur) {
            $event.currentTarget.blur();
        }
    };

    this.addClientsPlaces = function () {
        _this.clients = _this.clients.map(client => ({
            ...client,
            places: [] // Add "places" to client
        }));
    
        // Add places to each client
        _this.clients.forEach(client => {
            _this.clientsAll.forEach(place => {
                if (client.id === place.clientId) {
                    client.places.push(place);
                }
            });
        });
    }

    _this.getCompanies();
    _this.addClientsPlaces();
    _this.loadApiToken();
  },
];
